import './_styles.scss';
import React from 'react';
import { MdClose } from 'react-icons/md';

export default class index extends React.Component {

  constructor(props) {
    super(props);
    this.state = { hidden: true };
    this.message = props.message || 'An Error Occurred';
  }

  componentWillReceiveProps = (props) => {

    if (!props.visible) return null;

    else this.setState({ hidden: false });

    const { duration } = props || { duration: 10000 };

    return setTimeout(() => {

      this.props.callback();

      this.setState({ hidden: true });

    }, duration);

  }

  render() {
    return (!this.state.hidden) && (
      <div className='Modal-Error-Message'>

        <div className="Message">{this.props.message}</div>

        <div className="Button" onClick={() => this.setState({ hidden: true })}>
          <MdClose className='icon'/>
        </div>

    </div>
    )
  }
}
